import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const EnrollmentCertificate = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  disabled,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  return (
    <div className="subscription-form--wrapper">
      <Form
        type="vertical"
        title={
          SUBSCRIPTION.FORM.PROOF.STUDENT_ID_OR_ENROLLMENT_CERTIFICATE.TITLE
        }
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={SUBSCRIPTION.FORM.PROOF.ENROLLMENT_CERTIFICATE}
                icon={<MdOutlineAccountBalanceWallet size={16} />}
                required={
                  !get(
                    disabled,
                    SUBSCRIPTION_FORM_KEYS.PROOF
                      .STUDENT_ID_OR_ENROLLMENT_CERTIFICATE,
                  )
                }
                optional={
                  get(
                    disabled,
                    SUBSCRIPTION_FORM_KEYS.PROOF
                      .STUDENT_ID_OR_ENROLLMENT_CERTIFICATE,
                  ) && SUBSCRIPTION.FORM.OPTIONAL
                }
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                listType="picture"
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                multiple
                onUpload={(fileList) => {
                  setFieldValue("proof.enrollmentCertificate", fileList);
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      enrollmentCertificate: fileList,
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(values, "proof.enrollmentCertificate", [])}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default EnrollmentCertificate;
